import React, { useEffect, useState } from 'react';

const AnimatedDots = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev.length >= 3) return '';
        return prev + '.';
      });
    }, 400);

    return () => clearInterval(interval);
  }, []);

  return (
    <span
      style={{
        display: 'inline-block',
        width: 'calc(var(--fs-xl)*1.132075)',
        textAlign: 'left'
      }}
    >
      {dots}
    </span>
  );
};

export default AnimatedDots;